(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('EventCustomerSector', EventCustomerSector);

    EventCustomerSector.$inject = ['$resource'];

    function EventCustomerSector ($resource) {
        var resourceUrl =  'api/event-customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
